import React from 'react';

interface FinalistHeaderProps {
  filterCategory: string;
  filterPillar: string;
  totalSubmissions: number;
}

const FinalistHeader: React.FC<FinalistHeaderProps> = ({
  filterCategory,
  filterPillar,
  totalSubmissions,
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-smdd-card border border-gray-300 p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div>
          <h2 className="text-2xl font-baijamjuree font-extrabold text-black mb-2">
            Overview
          </h2>
          <div className="space-y-1">
            <p className="text-gray-600 font-baijamjuree">
              Category:{' '}
              <span className="font-semibold text-gray-900">
                {filterCategory === 'all' ? 'All Categories' : filterCategory}
              </span>
            </p>
            <p className="text-gray-600 font-baijamjuree">
              Pillar:{' '}
              <span className="font-semibold text-gray-900">
                {filterPillar === 'all'
                  ? 'All Pillars'
                  : filterPillar === 'Others'
                    ? 'Initiative'
                    : filterPillar}
              </span>
            </p>
          </div>
        </div>

        {/* Statistics Cards */}
        <div className="flex flex-wrap gap-3">
          <div className="bg-green-50 rounded-lg px-4 py-2 text-center w-28">
            <div className="text-2xl font-bold text-green-700 font-baijamjuree">
              {totalSubmissions}
            </div>
            <div className="text-xs text-green-600 font-baijamjuree uppercase tracking-wide">
              Finalists
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinalistHeader;
